<script setup lang="ts">
import type { Notification } from '@/types/models';
import NotificationAvatar from './NotificationAvatar.vue';
import { format } from 'date-fns';
import {
    constructNotificationBody,
    constructNotificationTitle,
} from '@/composables/notifications';

defineProps<{
    notification: Notification;
}>();
</script>

<template>
    <div
        class="relative w-full flex gap-2 p-4 transition-colors text-start items-center"
    >
        <!-- Unread indicator -->
        <span
            v-if="!notification.read_at"
            class="absolute start-1 top-1/2 -translate-y-1/2 size-2 rounded-full bg-negative-500"
        />

        <!-- Avatar -->
        <NotificationAvatar :type="notification.type" />

        <!-- Content -->
        <div class="flex-1 min-w-0 flex flex-col gap-1">
            <div class="flex flex-col gap-1">
                <!-- Title -->
                <span class="text-caption-1 font-bold text-gray-1000">
                    {{ constructNotificationTitle(notification) }}
                </span>

                <!-- Body -->
                <span
                    class="text-caption-1 text-gray-1000 line-clamp-2"
                    v-html="constructNotificationBody(notification)"
                />
            </div>

            <!-- Timestamp -->
            <span class="text-caption-1 text-gray-600">
                {{ format(new Date(notification.created_at), 'HH:mm a') }}
            </span>
        </div>
    </div>
</template>
